import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import PhotoGallarySlyder from './../block/PhotoGallarySlyder'
import NetPhotoMiniBlock from './../block/NetPhotoMiniBlock'
import Social from './../block/Social'
import Takze from './../block/Takze'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'
import Keysi from './../block/Keysi'

class Portfolio extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <Breadcrumbs items={data?.breadcrumbs || []} />
        <PhotoGallarySlyder
          data={data?.photogallary || {}}
          margin={`top-30-bottom-10`}
        />
        <NetPhotoMiniBlock
          text={data?.photogallary?.podpis}
          btn={data?.id == 33 ? `Запросить фото` : `Заказать деревянные окна`}
          text2={data?.id == 33 ? `Хотите быть в числе наших довольных клиентов?` : `Хотите деревянные окна?`}
          grid={data?.id == 33 ? `grid3` : `grid2`}
        />
        {data?.keysi?.list.length > 0 &&
          <Keysi
            data={data?.keysi || {}}
          />
        }
        {data?.photogallary2?.list.length > 0 &&
          <PhotoGallarySlyder
            data={data?.photogallary2 || {}}
            count={3}
            margin={`y`}
          />
        }
        <Social
          data={data?.social || {}}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
          vklink={data?.vklink}
          youlink={data?.youlink}
          rutubelink={data?.rutubelink}
        />
        <Takze
          data={data?.ourvalues || {}}
          id={data?.id || 0}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
        />
      </>
    )
  }
}

Portfolio.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Portfolio.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Portfolio